import { InfoItemProps } from "@/components/organisms";
import i18n from "@/i18n";

export const panelDescriptionSchema = (details: MyBrokerApi.ObjVar): InfoItemProps[] => [
    {
        key: "type",
        label: i18n.t("Common.Type"),
        value: details?.type?.name,
    },
    {
        key: "description",
        label: i18n.t("Common.Description"),
        value: details?.description,
    },
];
